export const dynamic = {
    es: {
		title: 'Reporte dinámico',
		header: {
			lastpush: 'Último push',
			totaltime: 'Tiempo total',
			mileage: 'Kilometraje',
			idletime: 'Tiempo inactivo',
			maxspeed: 'Velocidad máxima',
		},
		trips: {
			title: 'Viajes / Paradas',
			trip: 'Viaje sin eventos | Viaje con {events} evento | Viaje con {events} eventos',
			stop: 'Parada sin eventos | Parada con {events} evento | Parada con {events} eventos',
			geofences: 'Sin geocercas | {geofences} geocerca | {geofences} geocercas',
			points: ['Inicio', 'Fin'],
		},
		events: {
			title: 'Eventos',
			geofences: 'Geocercas',
			duration: 'Duración',
			address: 'Dirección',
			inmove: 'Tiempo en movimiento',
			speed: 'Velocidad promedio',
			range: ['a las', 'a'],
		},
		map: {
			geofence: 'Geocerca',
			coordinates: 'Coordenadas',
			speed: 'Velocidad',
			speedlimit: 'Limite de velocidad',
			diff: 'Diferencia',
			idle: 'Inactivo',
			time: 'Hora del evento',
			address: 'Dirección',
			duration: 'Duración',
			battery: 'Batería',
			min: 'Mínimo',
			max: 'Máximo',
			temp: 'Temperatura',
			gas: 'Actual',
		},
	},
	en: {
		title: 'Dynamic report',
		header: {
			lastpush: 'Last push',
			totaltime: 'Total time',
			mileage: 'Mileage',
			idletime: 'Idle time',
			maxspeed: 'Max Speed',
		},
		trips: {
			title: 'Trips / Stops',
			trip: 'Trip without events | Trip with {events} event | Trip with {events} events',
			stop: 'Stop without events | Stop with {events} event | Stop with {events} events',
			geofences: 'No geofences | {geofences} geofence | {geofences} geofences',
			points: ['Start', 'End'],
		},
		events: {
			title: 'Events',
			geofences: 'Geofences',
			duration: 'Duration',
			address: 'Address',
			inmove: 'Moving time',
			speed: 'Average speed',
			range: ['at', 'to'],
		},
		map: {
			geofence: 'Geofence',
			coordinates: 'Coordinates',
			speed: 'Speed',
			speedlimit: 'Speed limit',
			diff: 'Difference',
			idle: 'Idle',
			time: `Event's time`,
			address: 'Address',
			duration: 'Duration',
			battery: 'Battery',
			min: 'Minimum',
			max: 'Maximum',
			temp: 'Temperature',
			gas: 'Current',
		},
	},
}
